export enum EInfoForTgbActions {
  fetchNewbuildingsInfoForTgbSuccess = 'fetchNewbuildingsInfoForTgb/success',
}
